import { prisma, AutomationFlows, Flow, Prisma } from "client";

// CREATE
export interface AutomationFlowInput extends AutomationFlows {
  flows: Flow[];
}
export const createAutomationFlow = async (data: AutomationFlowInput) => {
  const automationFlow = await prisma.automationFlows.create({
    data: {
      ...data,
      nodes: data.nodes as Prisma.InputJsonValue[],
      edges: data.edges as Prisma.InputJsonValue[],
      flows: {
        create: data.flows.map((flow: Flow) => {
          return {
            type: flow.type,
            id: flow.id,
            rule: flow.rule,
            action: flow.action,
            nodeId: flow.nodeId,
          };
        }),
      },
    },
  });
  return automationFlow;
};

// READ
export const getAllAutomationFlows = async (): Promise<{
  automationFlows?: AutomationFlows[];
  error?: any;
}> => {
  try {
    const automationFlows = await prisma.automationFlows.findMany();
    return { automationFlows };
  } catch (error) {
    return { error };
  }
};

export const getAutomationFlowById = async (id: string) => {
  const automationFlow = await prisma.automationFlows.findUnique({
    where: { id },
    include: {
      flows: true,
    },
  });
  return automationFlow;
};

export const getAutomationFlowByEventId = async (eventId: string) => {
  try {
    const automationFlow = await prisma.automationFlows.findUnique({
      where: { eventId },
      include: {
        flows: true,
      },
    });
    return automationFlow;
  } catch (error) {
    return { error };
  }
};

// UPDATE
export const updateAutomationFlowById = async (
  id: string,
  data: AutomationFlowInput
) => {
  const flowsToUpdate = data.flows.filter((flow) => flow.id);
  const flowsToCreate = data.flows.filter((flow) => !flow.id);
  const updatedFlow = await prisma.automationFlows.update({
    where: { id },
    data: {
      ...data,
      nodes: data.nodes as Prisma.InputJsonValue[],
      edges: data.edges as Prisma.InputJsonValue[],
      flows: {
        update: flowsToUpdate.map((flow) => {
          return {
            where: { id: flow.id },
            data: {
              type: flow.type,
              rule: flow.rule,
              action: flow.action,
              nodeId: flow.nodeId,
            },
          };
        }),
        create: flowsToCreate.map((flow) => {
          return {
            type: flow.type,
            rule: flow.rule,
            action: flow.action,
            nodeId: flow.nodeId,
          };
        }),
      },
    },
  });
  return updatedFlow;
};

// DELETE

export const deleteAutomationFlowById = async (id: string) => {
  return await prisma.automationFlows.delete({
    where: { id },
  });
};
